export default "__VITE_ASSET__CWHg_126__"